import React from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export const formatPostContent = (content: string, postId?: string) => {
  // Split content into parts that match mentions (@username) or hashtags (#tag)
  const parts = content.split(/([@#][a-zA-Z0-9_]+)/g);

  return parts.map((part, index) => {
    if (part.startsWith('@')) {
      const username = part.slice(1);
      return (
        <Link
          key={index}
          to={`/profile/${username}`}
          className="text-blue-500 hover:underline font-medium"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </Link>
      );
    } else if (part.startsWith('#')) {
      const tag = part.slice(1);
      
      // Track hashtag usage when rendering
      if (postId) {
        trackHashtagUsage(tag, postId);
      }
      
      return (
        <Link
          key={index}
          to={`/hashtags/${tag}`}
          className="text-purple-500 hover:underline font-medium"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </Link>
      );
    }
    return part;
  });
};

export const extractHashtags = (content: string): string[] => {
  const hashtags = content.match(/#([a-zA-Z0-9_]+)/g);
  return hashtags ? hashtags.map(tag => tag.slice(1)) : [];
};

const trackHashtagUsage = async (tag: string, postId: string) => {
  try {
    // Check if hashtag exists and get/create it
    const { data: hashtagId } = await supabase
      .rpc('increment_hashtag_usage', { hashtag_name: tag });

    if (hashtagId) {
      // Link hashtag to post
      await supabase
        .from('post_hashtags')
        .upsert({ post_id: postId, hashtag_id: hashtagId }, { 
          onConflict: 'post_id,hashtag_id',
          ignoreDuplicates: true 
        });
    }
  } catch (error) {
    console.error('Error tracking hashtag:', error);
  }
};